import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Methods } from '../../shared/methods';
import { DinamicData, Cell } from '../../models/dinamic-data';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InventoryhistoryService } from '../../services/inventoryhistory.service';
import { UserService } from "../../services/user.service";
import { PrincipalinventoryService } from '../../services/principalinventory.service';
import { MatDialog } from '@angular/material/dialog';
import { CrudInventoryComponent } from '../inventory/crud-inventory/crud-inventory.component';
import { Title } from '@angular/platform-browser';
import { ConfigService } from '../../services/config.service';
import { TitleService } from '../../services/title.service';
import { SecurazeService } from "../../services/securaze.service";
import { MobilesdevicesService } from "../../services/mobilesdevices.service"
declare var $: any;
@Component({
  selector: 'app-inventory-history',
  templateUrl: './inventory-history.component.html',
  styleUrls: ['./inventory-history.component.css']
})
export class InventoryHistoryComponent implements OnInit {

  @ViewChild('childScrollElement') childScrollElement: ElementRef;

  public mtds: Methods = new Methods();
 public data: DinamicData = new DinamicData(
    [
      'ID',
      'Item',
      'Brand',
      'SN',
      'Category',
      'Description',
      'Condition',
      'PO-Line',
      'QTY',
      'Cost',
      'Sales Price',
      'Status',
      'Receive Status',
      'SO - Line',
      'SO Rep',
      'Warehouse',
      'PO Rep',
      'Update Date',
      'Customer Asset Tag',
      'Location',
      'Testing Status',
      'Added',
      'Date Received',
      'IQ ID',
      'Original ID',
      'Vendor',
      'Actions'
    ]
  );
  public loading = false;
  public apikey;
  public identity;

   /*SECCIÓN PARA MOSTRAR INFORMACIÓN AL SELECCIONAR COLUMNA*/
  public showDetails = false;
  public showSpecs = false;
  public showSpecsWorkflow = false;
  public workflow: string[][];
  public internalComments;
  public systemComments;
  public disabled = true;
  public token;
  public batteries: string[][];
  public components: string[][];
  public cpus: string[][];
  public hdds: string[][];
  public memories: string[][];
  public networks: string[][];
  public system: string[][];
  public testing: string[][];
  public video: string[][];
  public poline;
  public mdm;
  public computrace;
  public tablaDinamicaSet:boolean = false;
  public options: Array<any> = [];
  public showBothSpecs = false;
  constructor(
    private titleService: Title,
    private _router: Router,
    private _service: InventoryhistoryService,
    private _principalService: PrincipalinventoryService,
    private _userService: UserService,
    private _config: ConfigService,
    public dialog: MatDialog,private titleServices: TitleService,private _securazeService: SecurazeService, private mobilesdevicesService: MobilesdevicesService) {
      this.titleService.setTitle( 'Inventory History' );
      this.identity = this._userService.getIdentity();
      this.apikey = this.identity.apiCompany;
      this.token = this._userService.getToken();
    }

  ngOnInit() {
    this.loading = true;
    this._config.getConfig('tableinventoryhistoryopti').subscribe(
      r => {
        //console.log("tabladinamica => ", r);
        if (r.data) {
          this.tablaDinamicaSet = true;
          this.options = JSON.parse(r.data.data);
          this.perpage = r.data.pageLimit;
        } else {
          this.tablaDinamicaSet = false;
          this.options = this.mtds.colopt(
            this.data.headers, []
          );
        }
        this.getData();
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
    this.titleServices.setTitle('Inventory History');

  }

  updateConfig(e) {
    this.options = e;
    //console.log("updateConfig => ", this.options);
    this._config.setConfig('tableinventoryhistoryopti', this.options).subscribe(
      r => {
        console.log(r);
      }
    );
  }

  public filterrigh = "";
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
    this.getData(null,false);
  }
  public search = '';
  public page = 1;
  public perpage = '10';
  public totalItems = 0;
  public totalPaginas = 1;

  public filtros = [
  ];

  getData(e = null, newfilter = true) {
    this.loading = true;

    this._service.showallopti(
      e !== null ? (this.page = e.page) : (this.page = 1),
      e !== null ? (this.perpage = e.perPage) : (this.perpage = '10'),
      e !== null ? (this.search = e.search) : (this.search = ''),
      '',
      '',
      this.filtros, this.filterrigh,this.sortStates
    ).subscribe(
      r => {
        console.log(r);

        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success') {

          this.page = Number(r.page_actual);
          this.perpage = String(r.items_per_page);
          this.totalItems = Number(r.total_items_count);
          this.totalPaginas = Number(r.total_pages);
          this.data.rows = [];

if (newfilter) {
           this.filtros = [
            { key: 'id', title: 'ID', value: '', type: 'contains', key_type: 'id_type', type_options: [
              { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
            ] },
    { key: 'item', title: 'Item', value: '', type: 'contains', key_type: 'item_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'mfgr', title: 'Brand', value: '', type: 'contains', key_type: 'mfgr_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'serialnumber', title: 'SN', value: '', type: 'contains', key_type: 'serialnumber_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'type', title: 'Category', value: '', type: 'contains', key_type: 'type_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'description', title: 'Description', value: '', type: 'contains', key_type: 'description_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'condition', title: 'Condition', value: '', type: 'contains', key_type: 'condition_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'po_line', title: 'PO-Line', value: '', type: 'equalto', key_type: 'po_line_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'quantity', title: 'QTY', value: '', type: 'startswith', key_type: 'quantity_type', type_options: [
      { value: 'startswith', name: 'Starts With' }
    ] },
    { key: 'cost', title: 'Cost', value: '', type: 'startswith', key_type: 'cost_type', type_options: [
      { value: 'startswith', name: 'Starts With' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' } ,  { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
    ] },
    { key: 'sale_price', title: 'Sale Price', value: '', type: 'startswith', key_type: 'sale_price_type', type_options: [
      { value: 'startswith', name: 'Starts With' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' } ,  { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
    ] },
    { key: 'status', title: 'Status', value: '', type: 'contains', key_type: 'status_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'receivestatus', title: 'Receive Status', value: '', type: 'contains', key_type: 'receivestatus_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'so', title: 'SO - Line', value: '', type: 'contains', key_type: 'so_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'so_rep', title: 'SO Rep', value: '', type: 'contains', key_type: 'so_rep_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'warehouse', title: 'Warehouse', value: '', type: 'contains', key_type: 'warehouse_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'po_rep', title: 'PO Rep', value: '', type: 'contains', key_type: 'po_rep_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'update_date', title: 'Update Date', value: '', type: 'contains', key_type: 'update_date_type', type_options: [
      { value: 'startswith', name: 'Starts With' }
    ] },
    { key: 'customerassettag', title: 'Customer Asset Tag', value: '', type: 'contains', key_type: 'customerassettag_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'location', title: 'Location', value: '', type: 'contains', key_type: 'location_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    /*
    { key: 'container_id', title: 'Container ID', value: '', type: 'contains', key_type: 'container_id_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    { key: 'id_virtual_container', title: 'Virtual Container ID', value: '', type: 'contains', key_type: 'id_virtual_container_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    ] },
    */
    { key: 'testing_status', title: 'Testing Status', value: '', type: 'contains', key_type: 'testing_status_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'added', title: 'Added', value: '', type: 'startswith', key_type: 'added_type', type_options: [
      { value: 'startswith', name: 'Starts With' }
    ] },
    { key: 'received', title: 'Date Received', value: '', type: 'startswith', key_type: 'received_type', type_options: [
      { value: 'startswith', name: 'Starts With' }
    ] },
    // { key: 'location', title: 'Location', value: '', type: 'contains', key_type: 'location_type', type_options: [
    //   { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
    // ] },
    { key: 'inventoryid', title: 'IQ ID', value: '', type: 'contains', key_type: 'inventoryid_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },
    { key: 'originalid', title: 'Original ID', value: '', type: 'contains', key_type: 'originalid_type', type_options: [
      { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }, { value: "notcontain", name: "Does Not Contain" },
    ] },

    { key: "vendor", title: "Vendor", value: "", type: "contains", key_type: "vendor_type", type_options: [
        { value: "nofilter", name: "No Filter" },{ value: "contains", name: "Contains" },{ value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },{ value: "equalto", name: "Equal To" },{ value: "notcontain", name: "Does Not Contain" },
      ],},

  ];
}

          for (const element of r.data) {
            
            let formattedDate = '';
            if (element.added && element.added.trim() !== '') {
              const date = new Date(element.added);
              // Verificamos que la fecha sea válida
              if (!isNaN(date.getTime())) {
                formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
              }
            }
            
            // Para el campo "datereceived"
            let formattedDateReceived = '';
            if (element.datereceived && element.datereceived.trim() !== '') {
              const datereceived = new Date(element.datereceived);
              if (!isNaN(datereceived.getTime())) {
                formattedDateReceived = `${datereceived.getMonth() + 1}/${datereceived.getDate()}/${datereceived.getFullYear()}`;
              }
            }
            const actionButtons = [
              { icon: 'remove_red_eye', action: 'Detail', color: 'info', value: element.id }
            ];
            this.data.rows.push (
              [
                new Cell(element.id),
              //  new Cell(element.id, {type: 'checkbox'}), // Check box
                new Cell(element.Item, {class: 'minwidth70'}), // Item
                new Cell(element.mfgr), // Brand
                new Cell(element.serialnumber), // Serial Number
                new Cell(element.itemdescrip), // Type
                new Cell(element.description, {class: 'no-wraptable', title: element.description}), // Description
                new Cell(element.conditioninventory), // Condition
                new Cell(element.ponumber !== null ? `${element.ponumber}-${element.poline}` : '', {class: 'fw-bold minwidth70', color: 'primary'}), // PO - Line
                new Cell(element.quantity), // Quantity
                new Cell(element.purchasecost), // Cost
                new Cell(element.unitprice), // Sales Price
                new Cell(element.status, {class: 'fw-bold minwidth70', color: element.status === 'Available' ? 'green' : 'orange'}), // Status
                new Cell(element.receivestatus, {class: 'fw-bold minwidth70', /* color: element.status === 'Available' ? 'green' : 'orange' */ }), // Receive Status
                new Cell(element.so2 !== null || element.so2! ? `${element.so2} - ${element.soLine}` : '', {class: 'fw-bold minwidth70', color: 'success'}), // SO
                new Cell(element.sorep
                  ? element.sorep
                      .split(' ') 
                      .map((word) => word[0]) 
                      .join('') 
                      .toUpperCase() 
                  : "",
                  { title: (element.sorep !== null && element.sorep !== null ? `${element.sorep} ${element.sorep}` : '')}), // SO Rep
                new Cell(element.WarehouseName !== null ? element.WarehouseName : null), // Warehouse
                new Cell(element.porep
                  ? element.porep
                      .split(' ') 
                      .map((word) => word[0]) 
                      .join('') 
                      .toUpperCase() 
                  : "",
                { title: (element.porep !== null && element.porep !== null ? `${element.porep} ${element.porep}` : '')}), // PO Rep
                new Cell(element.lastupdated, {type: 'date'}), // Updated Date
                new Cell(element.customerAsset), // Customer Asset Tag
                new Cell(element.location), // Location
                // new Cell(element.weightItem ? element.weightItem.id : ''),
                // Container id
                // new Cell(element.idVirtualContainer), // Virtual Container id
                new Cell(this.mtds.capitalize(element.testingStatus), {class: 'minwidth70'}), // Testing Status
                new Cell(formattedDate, {
                  style: "width: 70px", 
                }), // Added Date
                new Cell(formattedDateReceived, {
                  style: "width: 70px", 
                }), // Date Received
                /* new Cell(element.location), // Location */
                new Cell(element.inventoryid), //IQ ID // ID
                new Cell(element.originalId), //Orignal Id
                new Cell(element.Vendorname !== null && element.Vendorname !== null ? `${element.Vendorname}` : ""), // PO Vendor
                new Cell(actionButtons, {type: 'actions'})
              ]
            );
            let item = {
              id: element.id,
              categories: element.categories,
            };

            this.itemsTree.push(item);
          }
          console.log("this.data => ", this.data);

        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  action(e) {
    console.log(e);
    switch (e.action) {
      case 'Detail':
        this._router.navigate(['/inventory', 'history', e.id]);
        // const dialogRef = this.dialog.open(CrudInventoryComponent, {
        //   width: '40%',
        //   data: {id:e.id, type: 'history'},
        // });

        // dialogRef.afterClosed().subscribe( (result) => {
        //   if (result) {
        //     this.getAll();
        //   }
        // });
        break;
        case 'Attribute':
          this.showDetails = true;
          this.showSpecs = false;
          this.showSpecsTree = false;
          this.showBothSpecs = false;
          this.batteries = [];
          this.components = [];
          this.cpus = [];
          this.hdds = [];
          this.memories = [];
          this.networks = [];
          this.system = [];
          this.testing = [];
          this.video = [];

          this.internalComments = '';
          this.systemComments = '';

          this.workflow = [];

          this._principalService.getAttributes(e.id, 'history').subscribe(
            response => {

              if(response.status === 'success'){

                if(response.data.testing){
                  this.mdm = response.data.testing.mdm;
                  this.computrace = response.data.testing.computrace;
                }

                this.batteries = response.data.batteries;
                this.components = response.data.components;
                this.cpus = response.data.cpus;
                this.hdds = response.data.hdds;
                this.memories = response.data.memories;
                this.networks = response.data.networks;
                this.system = response.data.system;
                this.testing[0] = response.data.testing;
                this.video = response.data.video;
                this.poline = response.data.inventory.poline;

                this.internalComments = response.data.inventory.internalComments;
                this.systemComments = response.data.inventory.systemcomments;

                this.showSpecs = true;
                if (this.showSpecs && this.showSpecsTree) {
                  this.showBothSpecs = true;
                  this.showSpecs = false;
                  this.showSpecsTree = false;
                }
              }else{
                this.internalComments = response.data.internalComments;
                this.systemComments = response.data.systemcomments;
              }

            }, error => {
              //this.mtds.notifyError('Inventory not found!');
              console.log("Error");
            }

          );

          /*const json = {
            apikey: this.apikey,
            data: e.id
          }

          this._principalService.getWorkflow(json).subscribe(
              response => {

                if (response._body) {
                  
                  let body = JSON.parse(response._body);

                  if(body.length > 0 ){
                    this.workflow = body;
                    this.showSpecsWorkflow = true;
                  }

                } 
              }, error => {
                console.log(error);
              }
            );*/
        break;
        case "showLogs":
        this.getdatabitraser(e)
        this.getdataphonecheck(e)
        this.showSpecsTree = false;
        this.selectedTabIndex = 2;

        this.getLogs(e.id);
        const resu = this.itemsTree.find((obj) => obj.id === e.id);
        console.log("test1")
        console.log(resu)
        console.log("test1")
        if (resu.categories !== null) {
          this._securazeService.getSpecsTree(this.token, e.id).subscribe(
            (response) => {
              if(response.data.children.length === 0){
                this.showSpecsTree = false;
              }else{
                this.showSpecsTree = true;
                this.selectedTabIndex = 0;
  
                this.specsTree = response.data;
                console.log(this.specsTree, "specstree");
              }

            },
            (error) => {
              console.log(error);
            }
          );
        }
        this.showDetails = true;
        this.showSpecs = false;

       //  this.showBothSpecs = false;

        this.batteries = [];
        this.components = [];
        this.cpus = [];
        this.hdds = [];
        this.memories = [];
        this.networks = [];
        this.system = [];
        this.testing = [];
        this.video = [];

        this.internalComments = "";
        this.systemComments = "";

        this.workflow = [];

        this._principalService.getAttributes(e.id, "history").subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              if (response.data.testing) {
                this.mdm = response.data.testing[0].mdm;
                this.computrace = response.data.testing[0].computrace;
              }

              this.batteries = response.data.batteries;
              this.components = response.data.components;
              this.cpus = response.data.cpus;
              this.hdds = response.data.hdds;
              this.memories = response.data.memories;
              this.networks = response.data.networks;
              this.system = response.data.system;
              this.testing[0] = response.data.testing[0];
              this.video = response.data.video;
              this.poline = response.data.inventory.poline;
              this.batchline = response.data.batchNumber;

              this.internalComments = response.data.inventory.internalComments;
              this.systemComments = response.data.inventory.systemcomments;

              this.showSpecs = true;

              // if (this.showSpecs && this.showSpecsTree) {
              //   this.showBothSpecs = true;
              //   this.showSpecs = false;
              //   this.showSpecsTree = false;
              // }
            } else {
              this.internalComments = response.data.internalComments;
              this.systemComments = response.data.systemcomments;
            }
          },
          (error) => {
            //this.mtds.notifyError('Inventory not found!');
            console.log("Error");
          }
        );

      break;
      default:
        break;
    }
  }
  /* Show Logs Fuctions  */
  public showSystemComments = false;
  public inventoryLogId;
  public logs: Array<any> = [];
  public showSpecsTree = false;
  selectedTabIndex: number = 1;
  public batchline;
  /* bitraser */
  public raserhardware = null;
  public raserbatery = null;
  public raserdisk = null;
  public raservideo = null;
  public raserhardwaretest = null;
  public rasermemory = null;
  public rasernetwork = null;
  public raserprocessor = null;
  public bitrasershow = false
  /* phonecheck */
  public phonecheckinfo = null;
  public phonecheckpart = null;
  public phonecheckshow = false;
  public itemsTree: Array<any> = [];
  public specsTree: Array<any> = [];
  getLogs(id) {
    this.showSystemComments = false;

    this.inventoryLogId = id;

    this._principalService.getLogs(id, "").subscribe((r) => {
      console.log(r);
      if (r.status === "success") {
        this.systemComments = "";
        this.logs = r.data;
        this.systemComments = r.systemComments;

        $("#modalLogs").modal("show");
        if (this.logs && !this.showSpecsTree) {
          this.selectedTabIndex = 1;
        } else if (this.logs && !this.showSpecsTree && this.showSpecs) {
          this.selectedTabIndex = 2;
        }
      }
    });
  }
  showSpecsFunction(param) {
    if (param === "TREE") {
      this.showSpecsTree = true;
      this.showSpecs = false;
    } else if (param === "EPS") {
      this.showSpecs = true;
      this.showSpecsTree = false;
    }
  }
  getdatabitraser(id){
    this.raserhardware = null
    this.raserbatery = null
    this.raserdisk = null
    this.raservideo = null
    this.raserhardwaretest = null
    this.rasermemory = null
    this.rasernetwork = null
    this.raserprocessor = null
this._securazeService.gedatabitraser(this.token, id.optionalValue).subscribe(
(response) => {
  if(response.status === "success"){
    this.bitrasershow = true
    this.raserhardware = response.data.hardwareInfo;
    this.raserbatery = response.data.batteryInfo;
    this.raserdisk = response.data.diskInfo;
    this.raservideo = response.data.graphisInfo;
    this.raserhardwaretest = response.data.hardwareTest;
    this.rasermemory = response.data.memoryInfo;
    this.rasernetwork = response.data.networkInfo;
    this.raserprocessor = response.data.proccessorInfo;
  }else{
    this.bitrasershow = false
  }

},
(error) => {
  this.phonecheckshow = false
  console.log(error);
}
);
}
getdataphonecheck(id){
this.phonecheckinfo = null;
this.phonecheckpart = null;
this.phonecheckshow = false;
/*  let testid="K9QH4CMV71" */
this.mobilesdevicesService.Getphonecheckdata(id.optionalValue).subscribe(
response => {
if(response.status === "success"){
  this.phonecheckshow = true
  this.phonecheckinfo = response.result;
  this.phonecheckpart = response.Parts.Data;
}else{
  this.phonecheckshow = false
}

},
error => {
this.phonecheckshow = false
console.error('Error:', error);
}
);

}
  /* END SHOW LOGS FUCTIONS */
  stopPropagation(event: WheelEvent): void {
    // Prevent the scroll event from bubbling up to the parent element
    event.stopPropagation();

    console.log(event);

    // Perform any other scrolling logic you need here
    // For example, you can manually adjust the child's scrollTop property.
    this.childScrollElement.nativeElement.scrollTop += event.deltaY;
  }

}
